export const primaryDividerBorder = 'border-gray-300 dark:border-gray-700'
export const secondaryDividerBorder = 'border-gray-200 dark:border-gray-800'
